import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../../utils/useLanguage";

// assets
import arrowIcon from "../../../assets/previous_icon.png";
import CustomInputWithUnit from "../../../components/CustomInputWithUnit";
import CustomInput from "../../../components/CustomInput";
import CustomCheckbox from "../../../components/CustomCheckbox";

const InternalPaperOrderListWithInput = ({
  data,
  selectedColors,
  onColorSelect,
  measuringUnit,
  currency,
  onInputChange,
  allSelectedRulers,
  collapsedRulers,
  setCollapsedRulers,
}) => {
  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");

  const collapsed = collapsedRulers || {};
  const setCollapsed = setCollapsedRulers;

  /* HANDLER FUNCTIONS */
  const handleCheckboxChange = (fabricCode, colorCode) => {
    onColorSelect(
      fabricCode,
      colorCode,
      !selectedColors[fabricCode]?.[colorCode]
    );
  };

  const toggleCollapse = (fabricCode) => {
    setCollapsed((prev) => ({
      ...prev,
      [fabricCode]: !prev[fabricCode],
    }));
  };

  // Find values from allSelectedRulers
  const getInputValue = (fabricCode, colorCode, field) => {
    const ruler = allSelectedRulers.find((r) => r.code === fabricCode);
    if (!ruler) return "";

    const color = ruler.colors.find((c) => c.colorCode === colorCode);
    if (!color) return "";

    return color[field] || "";
  };

  const handleInputValueChange = (fabricCode, colorCode, field, value) => {
    if (onInputChange) {
      onInputChange(fabricCode, colorCode, field, value);
    }
  };

  useEffect(() => {
    const initialCollapsed = {};
    data.forEach((fabric) => {
      if (!(fabric.code in collapsed)) {
        initialCollapsed[fabric.code] = true; // collapsed by default
      }
    });

    // Only update if there are new entries
    if (Object.keys(initialCollapsed).length > 0) {
      setCollapsed((prev) => ({
        ...prev,
        ...initialCollapsed,
      }));
    }
  }, [data]);

  return (
    <div
      className="c-fabric-table o-column o-column--gap-size_400 u-margin u-margin--bottom_700"
      dir={currentDirection}
    >
      {data.map((fabric) => (
        <div key={fabric.code} className="c-fabric-block">
          <div
            className="c-fabric-header"
            onClick={() => toggleCollapse(fabric.code)}
          >
            <span className="c-collapse-icon" style={{ cursor: "pointer" }}>
              <img
                src={arrowIcon}
                alt="Collapse"
                style={{
                  width: 16,
                  transform: collapsed[fabric.code]
                    ? "rotate(0deg)"
                    : "rotate(-90deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </span>

            <span className="c-fabric-code">
              {t("code")}: {fabric.code}
            </span>
          </div>

          {!collapsed[fabric.code] && (
            <table className="c-fabric-inner-table">
              <thead>
                <tr>
                  <th>{t("choose")}</th>
                  <th>{t("categoryName")}</th>
                  <th>{t("paperType")}</th>
                  <th>{t("dimension")}</th>
                  <th>{t("paperThickness")}</th>
                  <th>{t("quantity")}</th>
                </tr>
              </thead>
              <tbody>
                {fabric.colors.map((color) => (
                  <tr key={color.colorCode}>
                    <td>
                      <CustomCheckbox
                        onClick={(e) => e.stopPropagation()}
                        checked={
                          selectedColors[fabric.code]?.[color.colorCode] ||
                          false
                        }
                        onChange={() =>
                          handleCheckboxChange(fabric.code, color.colorCode)
                        }
                      />
                    </td>
                    <td>{color.colorCode}</td>

                    <td>
                      <CustomInput
                        value={getInputValue(
                          fabric.code,
                          color.colorCode,
                          "paperType"
                        )}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "paperType",
                            e.target.value
                          )
                        }
                        type="text"
                      />
                    </td>

                    <td>
                      <CustomInputWithUnit
                        value={getInputValue(
                          fabric.code,
                          color.colorCode,
                          "dimension"
                        )}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "dimension",
                            e.target.value
                          )
                        }
                        unit={t("cm")}
                        type="moneyV2"
                      />
                    </td>

                    <td>
                      <CustomInputWithUnit
                        value={getInputValue(
                          fabric.code,
                          color.colorCode,
                          "paperThickness"
                        )}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "paperThickness",
                            e.target.value
                          )
                        }
                        unit={t("gram")}
                        // type="moneyV2"
                      />
                    </td>

                    <td>
                      <CustomInputWithUnit
                        value={getInputValue(
                          fabric.code,
                          color.colorCode,
                          "quantity"
                        )}
                        onChange={(e) =>
                          handleInputValueChange(
                            fabric.code,
                            color.colorCode,
                            "quantity",
                            e.target.value
                          )
                        }
                        unit={t("ton")}
                        // type="moneyV2"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ))}
    </div>
  );
};

export default InternalPaperOrderListWithInput;
